var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-footer',[_c('ion-toolbar',[_c('db-components',{attrs:{"components":_vm.params.components}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }